import styled from 'styled-components'
import { theme } from '../../styles/theme'

interface IProps {
  isReceived: boolean
}

export const Container = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 4px;
  align-self: ${({ isReceived }) => (isReceived ? 'flex-start' : 'flex-end')};

  overflow: hidden;

  max-width: 70%;
  border-radius: ${({ isReceived }) => (isReceived ? '24px 24px 0px 0px' : '24px 24px 0px 24px')};
`

export const Hour = styled.div`
  font-size: ${theme.font.sizes.xsmall};
  color: ${theme.colors.gray700};

  margin-left: 20px;
`

export const Content = styled.div<IProps>`
  padding: 16px;
  background-color: ${({ isReceived }) => (isReceived ? theme.colors.gray100 : theme.colors.green2)};
  border-radius: ${({ isReceived }) => (isReceived ? '24px 24px 24px 0px' : '24px 24px 0px 24px')};

  font-size: ${theme.font.sizes.normal};
  color: ${({ isReceived }) => (isReceived ? theme.colors.black : theme.colors.white)};

  word-break: break-word;
`
